module.exports = __webpack_public_path__ + "img/stage-progress.67af1831.png";